import { CircularProgress } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useAuth } from '../components/Auth/AuthContext/AuthContext';

function Login() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const returnTo = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('returnTo') || params.get('to') || params.get('redirectTo') || '/';
  }, [location.search]);

  useEffect(() => {
    if (isLoading) return;

    if (isAuthenticated) {
      navigate(returnTo, { replace: true });
      return;
    }

    void loginWithRedirect({
      appState: { returnTo },
    });
  }, [isAuthenticated, isLoading, loginWithRedirect, navigate, returnTo]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <CircularProgress />
    </div>
  );
}

export default Login;
